module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDAwIiBoZWlnaHQ9IjU1MCIgdmlld0JveD0iMCAwIDc1IDE4IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48cGF0aCBmaWxsPSIjOGQxYjNkIiBkPSJNMCAwaDc1djE4SDB6Ii8+PHBhdGggZD0iTTIyIDE4SDBWMGgyMmw2IDEtNiAxIDYgMS02IDEgNiAxLTYgMSA2IDEtNiAxIDYgMS02IDEgNiAxLTYgMSA2IDEtNiAxIDYgMS02IDEgNiAxeiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/qat.svg
// module id = eUyL
// module chunks = 0